export const SET_USER = 'SET_USER';
export const CHANGE_EMAIL = 'CHANGE_EMAIL';
export const UPDATE_ENABLE_ALERT = 'UPDATE_ENABLE_ALERT';
